import ApiFaqPost from 'types/api/FaqPost';

import FaqCategory from 'models/FaqCategory';
import Model from 'models/Model';

export default class FaqPost implements Model {
    id: string;
    title: string;
    slug: string;
    content: string;
    category: FaqCategory;

    constructor(data: ApiFaqPost) {
        this.id = data.id;
        this.title = data.title;
        this.slug = data.slug;
        this.content = data.content;
        this.category = data.category && new FaqCategory(data.category);
    }
}